export enum AppTitle {
  tariffManagement = 'Tariff Management',
}
